export default __webpack_public_path__ + "static/media/config-probation-illustration.1be3cc14.svg";